import { render, staticRenderFns } from "./FilterLabel.vue?vue&type=template&id=3b0b1cce&scoped=true&"
import script from "./FilterLabel.vue?vue&type=script&lang=js&"
export * from "./FilterLabel.vue?vue&type=script&lang=js&"
import style0 from "./FilterLabel.vue?vue&type=style&index=0&id=3b0b1cce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0b1cce",
  null
  
)

export default component.exports